<div class="box box-danger text-center" [ngStyle]="
{
    'position': 'relative',
    'border-radius': '3px',
    'background': '#ffffff',
    'border': '2px solid #d2d6de',
    'margin-bottom': '20px',
    'width': '100%',
    'box-shadow': '0 1px 1px rgba(0,0,0,0.1)',

    'border-top-color': box.boxBorderColor,
    'border-bottom-color': box.boxBorderColor
}

">

  <div class="box-header with-border ">

    <a class="link" routerLink="{{ box.boxHeaderTitleLink }}">
      <h3 class="box-title" style="font-weight: 500;">
        <i class="{{box.boxHeaderTitleIcon}}"></i> {{box.boxHeaderTitle}}
      </h3>
    </a>

  </div>

  <div class="box-body">

    <h3>{{box.boxContentValue}}</h3>

  </div>

  <box-loading class="overlay" *ngIf="loadingSpin"></box-loading>
</div>